module.exports = __webpack_public_path__ + "img/logo1.9ba78071.png";